// extracted by mini-css-extract-plugin
export default {"line":"frozen_line__JjQiB"};